module.exports = __webpack_public_path__ + "img/penha_hill.a88f627e.jpg";